import React, { Component, useEffect, useState } from 'react';
import { Input, Button, Row, Col } from 'antd';
import { PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import LinkCount from './LinkCount';
const { TextArea } = Input;

export default function InputList({ UpdateItems, links = null }) {
    const [items, setItems] = useState(['', '']);

    useEffect(() => {
        !!links && setItems(links);
        !links && setItems(['', '']);
    }, []);

    const HandleAddItem = () => {
        const prev = [...items];
        prev.push('');
        setItems(prev);
        console.log({ Items: prev });
        UpdateItems(prev);
    };

    const HandleInputChange = (e, index) => {
        const prev = [...items];
        prev[index] = e.target.value;
        setItems(prev);
        UpdateItems(prev);
    };

    const HandleInputRemove = index => {
        let prev = [...items];
        const removedItems = prev.splice(index, 1);
        console.log({ removedItems, index, prev });
        setItems(prev);
        UpdateItems(prev);
    };

    return (
        <>
            <Row
                style={{
                    width: '100%',
                    margin: '10px 0',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <Col flex="auto"></Col>
                <Col flex="30px">
                    <Button type="primary" onClick={() => HandleAddItem()}>
                        <PlusCircleOutlined />
                    </Button>
                </Col>
                <Col flex="30px">
                    <LinkCount link={items} />
                </Col>
            </Row>
            {/* <div style={{ display: 'flex' }}>
                <Button type="primary" onClick={() => HandleAddItem()}>
                    <PlusCircleOutlined />
                </Button>
                <span>Sku Count</span>
                <LinkCount link={items} />
            </div> */}
            <div
                style={{
                    width: '100%',
                    maxHeight: '50vh',
                    padding: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    overflow: 'auto',
                    border: '1px dashed black',
                }}
            >
                {items?.map((item, index) => {
                    return (
                        <div
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                margin: '5px',
                                padding: '10px',
                                backgroundColor: '#eee',
                                borderRadius: '10px',
                            }}
                        >
                            <Row style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                <Col flex="25px">
                                    <p
                                        style={{
                                            marginRight: '10px',
                                            backgroundColor: 'black',
                                            borderRadius: '50%',
                                            color: 'white',
                                            width: '80%',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {index + 1}
                                    </p>
                                </Col>
                                <Col flex="auto">
                                    <TextArea
                                        autoSize
                                        style={{ marginRight: '10px', maxHeight: '150px' }}
                                        value={item}
                                        onChange={e => HandleInputChange(e, index)}
                                    />
                                </Col>
                                <Col flex="40px">
                                    <Button onClick={() => HandleInputRemove(index)} style={{ margin: '0 5px' }}>
                                        <DeleteOutlined />
                                    </Button>
                                </Col>
                                <Col flex="40px">
                                    <Button type="primary" onClick={() => HandleAddItem()} style={{ margin: '0 5px' }}>
                                        <PlusCircleOutlined />
                                    </Button>
                                </Col>
                                <Col flex="40px">
                                    <LinkCount link={item} />
                                </Col>
                            </Row>
                        </div>
                    );
                })}
            </div>
        </>
    );
}
